import ProjectCard from './ProjectCard';

const projects = [
  {
    image: '/images/amazon.png',
    alt: 'Amazon',
    title: 'Amazon',
    description: `It's a try to mimic Amazon and cover basic features on it, you can register and log in as a user or seller. As a user, you can surf through products and buy and control your account, orders & payment methods. As a seller, you can add your products for sale, edit & delete them. The website is multilingual and has other features.`,
    tags: [
      { title: 'Angular', src: '/images/angular.png', alt: 'Angular', width: '32px' },
      { title: 'NodeJS', src: '/images/nodejs.png', alt: 'NodeJS', width: '32px' },
      { title: 'ExpressJS', src: '/images/express.png', alt: 'ExpressJS', width: '32px' },
      { title: 'MongoDB', src: '/images/mongodb.png', alt: 'MongoDB', width: '32px' },
      { title: 'Sass', src: '/images/sass.png', alt: 'Sass', width: '32px' },
      { title: 'Bootstrap', src: '/images/bootstrap.png', alt: 'Bootstrap', width: '32px' },
      { title: 'Netlify', src: '/images/netlify.png', alt: 'Netlify', width: '32px' },
    ],
    link: 'https://iti-amazon-mearn.netlify.app',
  },
  {
    image: '/images/adminpanel.png',
    alt: 'Amazon Admin Panel',
    title: 'Amazon Admin Panel',
    description: `It's a dashboard for the cloned amazon website, where the admin has full control of all categories.`,
    tags: [
      { title: 'Angular', src: '/images/angular.png', alt: 'Angular', width: '32px' },
      { title: 'NodeJS', src: '/images/nodejs.png', alt: 'NodeJS', width: '32px' },
      { title: 'ExpressJS', src: '/images/express.png', alt: 'ExpressJS', width: '32px' },
      { title: 'MongoDB', src: '/images/mongodb.png', alt: 'MongoDB', width: '32px' },
      { title: 'Sass', src: '/images/sass.png', alt: 'Sass', width: '32px' },
      { title: 'Bootstrap', src: '/images/bootstrap.png', alt: 'Bootstrap', width: '32px' },
      { title: 'Firebase', src: '/images/firebase.png', alt: 'Firebase', width: '32px' },
    ],
    link: 'https://ama-zon-admin-panel.web.app',
  },
  {
    image: '/images/covid19.png',
    alt: 'COVID-19 Dashboard',
    title: 'COVID-19 Dashboard',
    description: (
      <>
        {`It's a COVID-19 real-time live dashboard that shows active cases, recovered & deaths in the states of the United States of America (USA)`}
        <br />
        <span>*the API that I used is got broken. I'm trying to find an alternative.</span>
      </>
    ),
    tags: [
      { src: '/images/html.png', alt: 'HTML5', width: '32px' },
      { src: '/images/css.png', alt: 'CSS3', title: 'CSS3', width: '32px' },
      { src: '/images/js.png', alt: 'JavaScript', title: 'JavaScript', width: '32px' },
      { src: '/images/bootstrap.png', alt: 'Bootstrap', title: 'Bootstrap', width: '32px' },
      { src: '/images/firebase.png', alt: 'Firebase', title: 'Firebase', width: '32px' },
    ],
    disabled: true,
  },
  {
    image: '/images/shoppmy.png',
    alt: 'Shopp.my',
    title: 'Shoppmy',
    description: `It's a simple online shop for buying electronic devices and other products. The website has a light/dark mode feature.`,
    tags: [
      { src: '/images/react.png', alt: 'React', title: 'React', width: '32px' },
      { src: '/images/sass.png', alt: 'Sass', title: 'Sass', width: '32px' },
      { src: '/images/firebase.png', alt: 'Firebase', title: 'Firebase', width: '32px' },
    ],
    link: 'https://shoppmyyy.web.app',
  },
  {
    image: '/images/jasminehome.png',
    alt: 'Jasmine Home',
    title: 'Jasmine Home',
    description: `Jasmine Home is a website for selling Egyptian cotton products, it's multilingual and contains attractive animations.`,
    tags: [
      { src: '/images/react.png', alt: 'React', title: 'React', width: '32px' },
      { src: '/images/bootstrap.png', alt: 'Bootstrap', title: 'Bootstrap', width: '32px' },
      { src: '/images/firebase.png', alt: 'Firebase', title: 'Firebase', width: '32px' },
    ],
    link: 'https://jasmin-home.web.app',
  },
  {
    image: '/images/efile.png',
    alt: 'e-File',
    title: 'e-File',
    description: `e-File is a contact list. You can log in and add, edit & delete your contacts.`,
    tags: [
      { title: 'Angular', src: '/images/angular.png', alt: 'Angular', width: '32px' },
      { title: 'NodeJS', src: '/images/nodejs.png', alt: 'NodeJS', width: '32px' },
      { title: 'ExpressJS', src: '/images/express.png', alt: 'ExpressJS', width: '32px' },
      { title: 'MongoDB', src: '/images/mongodb.png', alt: 'MongoDB', width: '32px' },
      { src: '/images/sass.png', alt: 'Sass', title: 'Sass', width: '32px' },
      { src: '/images/bootstrap.png', alt: 'Bootstrap', width: '32px' },
      { title: 'Firebase', src: '/images/firebase.png', alt: 'Firebase', width: '32px' },
    ],
    link: 'https://e-filee.web.app',
  },
  {
    image: '/images/pharmoscope.png',
    alt: 'Pharmoscope',
    title: 'PharmoScope',
    description: `Pharmoscope is a medical agency provides high quality online clinical pharmacy services and medical content creation.`,
    tags: [
      { title: 'React', src: '/images/react.png', alt: 'React', width: '32px' },
      { src: '/images/sass.png', alt: 'Sass', title: 'Sass', width: '32px' },
      { src: '/images/bootstrap.png', alt: 'Bootstrap', width: '32px' },
      { title: 'Firebase', src: '/images/firebase.png', alt: 'Firebase', width: '32px' },
    ],
    link: 'https://egpharmoscope.web.app/',
  },
];

export const Projects = () => {
  return (
    <div id='projects' className='row'>
      <div className='col-12 text-center mb-3'>
        <h1 className='section-title'>Projects</h1>
      </div>
      <div className='col-1'> </div>
      <div className='col-10 mb-5'>
        <div className='row'>
          {projects.map((project, idx) => (
            <ProjectCard key={idx} {...project} />
          ))}
        </div>
      </div>
      <div className='col-1'> </div>
    </div>
  );
};
